import { defaultPropertyDefinitions as propertyDefinitions } from "@buildwithflux/constants";
import { getPartType } from "@buildwithflux/models";
import { getPropertyValueIfString } from "../../property/PropertyAPI";
import { partTypeMapping } from "./mappings/partTypeMapping";
// A bunch if classifiers that will try to guess the right value based on a bunch of fuzzy heuristics
export function inductorTypeClassifier(partVersionData) {
    const rawPartType = getPartType(partVersionData);
    const inductorType = getPropertyValueIfString(propertyDefinitions.inductor_type.label, partVersionData.properties);
    const partMetadataStringLower = (inductorType ? inductorType : rawPartType + " " + partVersionData.name + " " + partVersionData.description).toLowerCase();
    if (partMetadataStringLower.includes("fixed") ||
        partMetadataStringLower.includes("power") ||
        partMetadataStringLower.includes("charging coil")) {
        return "Fixed";
    }
    else if (partMetadataStringLower.includes("variable")) {
        return "Variable";
    }
    return "Other";
}
export function transistorTypeClassifier(partVersionData) {
    const rawPartType = getPartType(partVersionData);
    const transistorType = getPropertyValueIfString(propertyDefinitions.transistor_type.label, partVersionData.properties);
    const partMetadataStringLower = (transistorType ? transistorType : rawPartType + " " + partVersionData.name + " " + partVersionData.description).toLowerCase();
    if (partMetadataStringLower.includes("npn")) {
        return "NPN";
    }
    else if (partMetadataStringLower.includes("pnp")) {
        return "PNP";
    }
    else if (partMetadataStringLower.includes("mosfet")) {
        return "MOSFET";
    }
    else if (partMetadataStringLower.includes("jfet")) {
        return "JFET";
    }
    else if (partMetadataStringLower.includes("igbt")) {
        return "IGBT";
    }
    else if (partMetadataStringLower.includes("bjt")) {
        return "BJT";
    }
    else if (partMetadataStringLower.includes("darlington")) {
        return "Darlington";
    }
    else if (partMetadataStringLower.includes("bipolar")) {
        return "Bipolar";
    }
    else if (partMetadataStringLower.includes("scr")) {
        return "SCR";
    }
    else if (partMetadataStringLower.includes("triac")) {
        return "TRIAC";
    }
    return "Other";
}
export function diodeTypeClassifier(partVersionData) {
    const rawPartType = getPartType(partVersionData);
    const diodeType = getPropertyValueIfString(propertyDefinitions.diode_type.label, partVersionData.properties);
    const partMetadataStringLower = (diodeType ? diodeType : rawPartType + " " + partVersionData.name + " " + partVersionData.description).toLowerCase();
    if (partMetadataStringLower.includes("schottky")) {
        return "Schottky";
    }
    else if (partMetadataStringLower.includes("zener")) {
        return "Zener";
    }
    else if (partMetadataStringLower.includes("rectifier")) {
        return "Rectifier";
    }
    else if (partMetadataStringLower.includes("light emitting") || partMetadataStringLower.includes("led")) {
        return "LED";
    }
    else if (partMetadataStringLower.includes("varactor")) {
        return "Varactor";
    }
    else if (partMetadataStringLower.includes("tunnel")) {
        return "Tunnel";
    }
    else if (partMetadataStringLower.includes("pin")) {
        return "PIN";
    }
    return "Other";
}
export function icTypeClassifier(partVersionData) {
    const rawPartType = getPartType(partVersionData);
    const integratedCircuitType = getPropertyValueIfString(propertyDefinitions.integrated_circuit_type.label, partVersionData.properties);
    const partMetadataStringLower = (integratedCircuitType
        ? integratedCircuitType
        : rawPartType + " " + partVersionData.name + " " + partVersionData.description).toLowerCase();
    for (const { keywords, category } of partTypeMapping) {
        if (keywords.some((keyword) => partMetadataStringLower.includes(keyword))) {
            return category;
        }
    }
    return "Other";
}
export function logicFunctionClassifier(partVersionData) {
    const rawPartType = getPartType(partVersionData);
    const rawIcType = getPropertyValueIfString(propertyDefinitions.integrated_circuit_type.label, partVersionData.properties);
    const partType = rawPartType || rawIcType;
    if (!partType) {
        return undefined;
    }
    for (const { keywords, logicFunction } of partTypeMapping) {
        if (keywords.some((keyword) => partType.toLowerCase().trim().includes(keyword))) {
            return logicFunction;
        }
    }
    return "Other";
}
export function connectorTypeClassifier(partVersionData) {
    const rawPartType = getPartType(partVersionData);
    const connectorType = getPropertyValueIfString(propertyDefinitions.connector_type.label, partVersionData.properties);
    const partMetadataStringLower = (connectorType ? connectorType : rawPartType + " " + partVersionData.name + " " + partVersionData.description).toLowerCase();
    if (partMetadataStringLower.includes("audio") ||
        partMetadataStringLower.includes("xlr") ||
        partMetadataStringLower.includes("rca") ||
        partMetadataStringLower.includes("headphone") ||
        partMetadataStringLower.includes("microphone") ||
        partMetadataStringLower.includes("phone") ||
        partMetadataStringLower.includes("video") ||
        partMetadataStringLower.includes("hdmi")) {
        return "Audio / Video Connectors";
    }
    else if (partMetadataStringLower.includes("automotive")) {
        return "Automotive Connectors";
    }
    else if (partMetadataStringLower.includes("backplane")) {
        return "Backplane Connectors";
    }
    else if (partMetadataStringLower.includes("board to board") ||
        partMetadataStringLower.includes("spring finger")) {
        return "Board to Board Connectors";
    }
    else if (partMetadataStringLower.includes("card edge") ||
        partMetadataStringLower.includes("pci") ||
        partMetadataStringLower.includes("barrel jack") ||
        partMetadataStringLower.includes("power jack") ||
        partMetadataStringLower.includes("edgeboard")) {
        return "Card Edge Connectors";
    }
    else if (partMetadataStringLower.includes("circular")) {
        return "Circular Connectors";
    }
    else if (partMetadataStringLower.includes("d-sub") ||
        partMetadataStringLower.includes("dsub") ||
        partMetadataStringLower.includes("d-type")) {
        return "D-Sub Connectors";
    }
    else if (partMetadataStringLower.includes("ffc") || partMetadataStringLower.includes("fpc")) {
        return "FFC / FPC";
    }
    else if (partMetadataStringLower.includes("fiber optic") || partMetadataStringLower.includes("optical")) {
        return "Fiber Optic Connectors";
    }
    else if (partMetadataStringLower.includes("header") ||
        partMetadataStringLower.includes("wire housing") ||
        partMetadataStringLower.includes("socket strip") ||
        partMetadataStringLower.includes("pinsocket") ||
        partMetadataStringLower.includes("pin socket")) {
        return "Headers and Wire Housings";
    }
    else if (partMetadataStringLower.includes("ic socket") || partMetadataStringLower.includes("component socket")) {
        return "IC and Component Sockets";
    }
    else if (partMetadataStringLower.includes("memory") ||
        partMetadataStringLower.includes("sd card") ||
        partMetadataStringLower.includes("micro sd") ||
        partMetadataStringLower.includes("sim card") ||
        partMetadataStringLower.includes("dimm") ||
        partMetadataStringLower.includes("simm") ||
        partMetadataStringLower.includes("ddr")) {
        return "Memory Connectors";
    }
    else if (partMetadataStringLower.includes("modular") ||
        partMetadataStringLower.includes("ethernet") ||
        partMetadataStringLower.includes("rj54") ||
        partMetadataStringLower.includes("ethercon")) {
        return "Modular / Ethernet Connectors";
    }
    else if (partMetadataStringLower.includes("photovoltaic") || partMetadataStringLower.includes("solar")) {
        return "Photovoltaic / Solar Connectors";
    }
    else if (partMetadataStringLower.includes("power") ||
        partMetadataStringLower.includes("mag connector") ||
        partMetadataStringLower.includes("banana")) {
        return "Power Connectors";
    }
    else if (partMetadataStringLower.includes("battery")) {
        return "Battery Holders";
    }
    else if (partMetadataStringLower.includes("rf") || partMetadataStringLower.includes("coaxial")) {
        return "RF / Coaxial Connectors";
    }
    else if (partMetadataStringLower.includes("terminal block") ||
        partMetadataStringLower.includes("block") ||
        partMetadataStringLower.includes("quick connect") ||
        partMetadataStringLower.includes("quick fit") ||
        partMetadataStringLower.includes("quick-fit")) {
        return "Terminal Blocks";
    }
    else if (partMetadataStringLower.includes("terminal")) {
        return "Terminals";
    }
    else if (partMetadataStringLower.includes("usb")) {
        return "USB Connectors";
    }
    return "Other";
}
export function capacitorTypeClassifier(partVersionData) {
    const rawPartType = getPartType(partVersionData);
    const capacitorType = getPropertyValueIfString(propertyDefinitions.capacitor_type.label, partVersionData.properties);
    const partMetadataStringLower = (capacitorType ? capacitorType : rawPartType + " " + partVersionData.name + " " + partVersionData.description).toLowerCase();
    if (partMetadataStringLower.includes("ceramic")) {
        return "Ceramic";
    }
    else if (partMetadataStringLower.includes("electrolytic")) {
        return "Electrolytic";
    }
    else if (partMetadataStringLower.includes("tantalum")) {
        return "Tantalum";
    }
    else if (partMetadataStringLower.includes("film")) {
        return "Film";
    }
    else if (partMetadataStringLower.includes("polymer")) {
        return "Polymer";
    }
    else if (partMetadataStringLower.includes("polyester")) {
        return "Polyester Film";
    }
    else if (partMetadataStringLower.includes("polypropylene")) {
        return "Polypropylene Film";
    }
    else if (partMetadataStringLower.includes("polystyrene")) {
        return "Polystyrene Film";
    }
    else if (partMetadataStringLower.includes("mica")) {
        return "Mica";
    }
    else if (partMetadataStringLower.includes("super") || partMetadataStringLower.includes("ultra")) {
        return "Supercapacitor";
    }
    else if (partMetadataStringLower.includes("glass")) {
        return "Glass";
    }
    else if (partMetadataStringLower.includes("silicon")) {
        return "Silicon";
    }
    else if (partMetadataStringLower.includes("variable") || partMetadataStringLower.includes("trimmer")) {
        return "Variable (Trimmer)";
    }
    else if (partMetadataStringLower.includes("array")) {
        return "Array";
    }
    return "Other";
}
export function resistorTypeClassifier(partVersionData) {
    const rawPartType = getPartType(partVersionData);
    const resistorType = getPropertyValueIfString(propertyDefinitions.resistor_type.label, partVersionData.properties);
    const partMetadataStringLower = (resistorType ? resistorType : rawPartType + " " + partVersionData.name + " " + partVersionData.description).toLowerCase();
    if (partMetadataStringLower.includes("carbon film")) {
        return "Carbon Film";
    }
    else if (partMetadataStringLower.includes("carbon composition")) {
        return "Carbon Composition";
    }
    else if (partMetadataStringLower.includes("metal oxide")) {
        return "Metal Oxide";
    }
    else if (partMetadataStringLower.includes("metal film")) {
        return "Metal Film";
    }
    else if (partMetadataStringLower.includes("wire wound") || partMetadataStringLower.includes("wirewound")) {
        return "Wirewound";
    }
    else if (partMetadataStringLower.includes("thick film")) {
        return "Thick Film";
    }
    else if (partMetadataStringLower.includes("thin film")) {
        return "Thin Film";
    }
    else if (partMetadataStringLower.includes("foil")) {
        return "Foil";
    }
    else if (partMetadataStringLower.includes("cement")) {
        return "Cement";
    }
    else if (partMetadataStringLower.includes("fusible")) {
        return "Fusible";
    }
    else if (partMetadataStringLower.includes("precision")) {
        return "Precision";
    }
    else if (partMetadataStringLower.includes("network") || partMetadataStringLower.includes("array")) {
        return "Network/Array";
    }
    else if (partMetadataStringLower.includes("variable") || partMetadataStringLower.includes("potentiometer")) {
        return "Variable (Potentiometer)";
    }
    else if (partMetadataStringLower.includes("thermistor")) {
        return "Thermistor";
    }
    else if (partMetadataStringLower.includes("photoresistor")) {
        return "Photoresistor";
    }
    else if (partMetadataStringLower.includes("surface mount") ||
        partMetadataStringLower.includes("surface-mount") ||
        partMetadataStringLower.includes("smd") ||
        partMetadataStringLower.includes("smt")) {
        return "Surface Mount";
    }
    else if (partMetadataStringLower.includes("through-hole") ||
        partMetadataStringLower.includes("through hole") ||
        partMetadataStringLower.includes("thm") ||
        partMetadataStringLower.includes("tht")) {
        return "Through-Hole";
    }
    else if (partMetadataStringLower.includes("zero ohm")) {
        return "Zero Ohm";
    }
    return "Other";
}
export function partTypeClassifier(partVersionData) {
    const partMetadataStringLower = partVersionData.name?.toLowerCase() + " " + partVersionData.description?.toLowerCase();
    if (partMetadataStringLower.includes("#generics")) {
        return "Generics";
    }
    else if (partMetadataStringLower.includes("#module")) {
        return "Modules";
    }
    return "Other";
}
//# sourceMappingURL=partAttributeClassifiers.js.map